module.exports = __webpack_public_path__ + "img/zhaoshang.b9ff1dab.jpg";